/**
 * Home page “latest release” promo. Update when you ship a new version
 * (keep in sync with the first entry in ReleasesSection and the release file).
 */
export const latestReleaseHome = {
  version: 'v1.9.2',
  /** Same style as the release sidebar: dd/Mmm/yyyy or TBC */
  date: '14th April 2026',
  title: 'Are you ready for the chop?!',
  /** One or two sentences for the summary card */
  summary:
    'Introducing the amazing new Pot Chop Calculator! 🎉',
  /** Optional short bullets (omit or leave empty [] if you only want the summary) */
  highlights: [
    'Big new feature: Advanced chop calculator with ICM, Chip Chop, Even Split, and a smart Deal Negotiator—plus \'leave money to play for\' support for real-world tournament deals.'],
};
